import { siteStats } from "@/mocks/community";
import { quickNews } from "@/mocks/feed";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[680px] flex items-end overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20night%20red%20carpet%20scene%20with%20blurred%20camera%20flashes%20and%20warm%20crimson%20and%20amber%20spotlights%20in%20haze%2C%20no%20identifiable%20faces%2C%20moody%20atmospheric%20editorial%20photography%2C%20dramatic%20lighting%2C%20high%20contrast&width=1920&height=1080&seq=hero-gossip-main&orientation=landscape"
        alt="黑料吃瓜情报站首屏主视觉"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/85" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-20 md:pb-24">
        <div className="max-w-5xl">
          <span className="inline-flex items-center gap-2 bg-primary-500/90 text-background-50 text-xs md:text-sm font-medium px-3 py-1.5 rounded-full">
            <i className="ri-fire-line animate-pulseSoft" />
            每日更新 · 全网吃瓜情报汇总
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-6xl font-bold leading-tight text-background-50 text-balance">
            黑料 · 明星网红吃瓜情报站
          </h1>
          <p className="mt-4 max-w-2xl text-sm md:text-lg leading-relaxed text-background-100">
            聚焦娱乐圈与网红圈的热门争议事件。从最新爆料时间线、人物档案到瓜田黑话词典，
            把散落各处的吃瓜线索整理成一份看得懂、追得上的完整汇总。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium px-5 md:px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line" />
              查看今日热瓜
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/40 text-sm md:text-base font-medium px-5 md:px-6 py-3 rounded-md transition-colors cursor-pointer backdrop-blur whitespace-nowrap"
            >
              <i className="ri-time-line" />
              浏览最新爆料
            </a>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-background-50/15 rounded-lg overflow-hidden border border-background-50/15">
          {siteStats.map((stat) => (
            <div key={stat.label} className="bg-foreground-950/40 backdrop-blur px-4 py-4 md:px-5 md:py-5">
              <div className="font-heading text-xl md:text-3xl font-bold text-accent-400">
                {stat.value}
              </div>
              <div className="mt-1 text-xs md:text-sm text-background-100/85">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 bg-foreground-950/85 backdrop-blur border-t border-background-50/10">
        <div className="flex items-center gap-3 px-4 md:px-8 h-11">
          <span className="flex items-center gap-1.5 shrink-0 text-accent-400 text-xs md:text-sm font-medium">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulseSoft" />
            快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee gap-8">
              {[...quickNews, ...quickNews].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="text-xs md:text-sm text-background-100/90 whitespace-nowrap"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}